import { hot } from 'react-hot-loader';

import { ApolloProvider } from '@apollo/client';
import { apolloClient, windowExists } from '@classity-edtech/ui-base';

import AppRoutes from './routes/routes';

import ScrollToTop from './components/ScrollToTop';
import FlashMessage from './components/FlashMessage';
import { GoogleOAuthProvider } from '@react-oauth/google';

const App = () => {
  return (
    <ApolloProvider client={apolloClient as any}>
      <GoogleOAuthProvider clientId={(windowExists?.__UI_CONFIG__ as any)?.googleClientId}>
        <FlashMessage />
        <ScrollToTop />
        <AppRoutes />
      </GoogleOAuthProvider>
    </ApolloProvider>
  );
};

App.propTypes = {};

App.defaultProps = {};

export default hot(module)(App);
